import { Building2, DollarSign, AlertTriangle, Activity } from "lucide-react";

interface PortfolioSummaryProps {
  totalLocations: number;
  combinedRevenue: number;
  alertCount: number;
  healthScore: number;
}

export default function PortfolioSummaryBar({ totalLocations, combinedRevenue, alertCount, healthScore }: PortfolioSummaryProps) {
  const healthColor = healthScore >= 80 ? "text-primary" : healthScore >= 60 ? "text-accent" : "text-destructive";

  return (
    <div className="border-b border-border bg-card">
      <div className="container py-3">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center">
              <Building2 className="w-4 h-4 text-foreground" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Locations</p>
              <p className="text-sm font-medium text-foreground">{totalLocations}</p>
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center">
              <DollarSign className="w-4 h-4 text-foreground" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Combined Revenue</p>
              <p className="text-sm font-medium text-foreground">${combinedRevenue.toLocaleString()}/mo</p>
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center">
              <AlertTriangle className={`w-4 h-4 ${alertCount > 0 ? "text-destructive" : "text-muted-foreground"}`} />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Alerts</p>
              <p className={`text-sm font-medium ${alertCount > 0 ? "text-destructive" : "text-foreground"}`}>{alertCount}</p>
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center">
              <Activity className={`w-4 h-4 ${healthColor}`} />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Portfolio Health</p>
              <p className={`text-sm font-medium ${healthColor}`}>{healthScore}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
